import React, { Component } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Tabs, Tab } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import ReactToPrint from "react-to-print";

import { getRecipeDetails, resetField, favouriteRecipe, unFavouriteRecipe, isfavouriteRecipe } from "../../../../store/actions";
import FilterPanel from "../../../../sharedComponents/filterPanel";
import { RecipeKeys } from "../../../../constants/recipeConstants";
import StarRating from "../../../../sharedComponents/starRating";
import PlaceholderIMG from "../../../../sharedComponents/placeholderImage";
import ImageSlider from "../../../../sharedComponents/imageSlider";
import RelatedRecipes from "./recipeRelated";
import RecipeServings from "./recipeServings";
import RecentRecipes from "./recipeRecent";
import RecipeNutritionFacts from "../add/recipeNutritionFacts";
import RecipeIngredients from "./recipeIngredients";
import RecipeCreateComment from "./recipeCreateComment";
import RecipeComments from "./recipeComments";
import Tooltip from "../../../../sharedComponents/tooltip";
import AddToJournal from "../../journal/add/addToJournalPanel";
import DeclineRecipePanel from "../listing/declineRecipePanel";
import "../listing/RecipesListing.scss";

class RecipeDetails extends Component {
	state = {
		recipeId: null,
		serveScale: 0,
		detailsActiveTab: 1,
		selectedRecipe: null,
		showDeclineRecipePanel: false,
		recipeToDecline: " "
	};

	componentDidMount() {
		const { match, getRecipeDetails, recipeList, isfavouriteRecipe } = this.props;
		const recipeId = get(match, "params.id", null);
		if (recipeId) {
			this.setState({ recipeId });
			getRecipeDetails(recipeId);
			isfavouriteRecipe(recipeId);
		}
		this.setState({ recipes: recipeList });
	}

	componentDidUpdate(prevProps) {
		const { match, getRecipeDetails, recipeDetails } = this.props;
		const recipeId = get(match, "params.id", null);
		if (prevProps.match !== match && recipeId && this.state.recipeId !== recipeId) {
			this.page &&
				this.page.scrollIntoView({
					block: "start",
					behavior: "smooth",
					inline: "nearest"
				});
			this.setState({ recipeId });
			getRecipeDetails(recipeId);
		}

		if (prevProps.recipeDetails !== recipeDetails) {
			this.setState({ serveScale: get(recipeDetails, "yields") });
		}
	}

	componentWillUnmount() {
		this.props.resetField("Recipes.recipeDetails", {});
	}

	renderImageContainer = () => {
		const { recipeDetails } = this.props;
		const recipeImages =
			recipeDetails && recipeDetails.images && recipeDetails.images.length > 1
				? recipeDetails.images.map((item) => {
						return {
							id: item.id,
							src: item.image_data.photo_l,
							name: item.image_data.name
						};
				  })
				: null;
		const recipeImage =
			recipeDetails && recipeDetails.images && recipeDetails.images.length === 1
				? get(recipeDetails.images[0], "image_data.photo_l", null)
				: get(recipeDetails, [RecipeKeys["IMAGES"], RecipeKeys["PHOTO_L"]], null);

		return (
			<div className={`${recipeImages ? "block-banner-slider" : "block-banner-image image-container"}`}>
				{this.renderDetailsHedaerNav(recipeDetails)}
				{recipeImages ? (
					<ImageSlider list={recipeImages} />
				) : (
					<PlaceholderIMG
						src={recipeImage}
						objectFit="cover"
						width="800"
						height="550"
						alt={recipeImage}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
					/>
				)}
				{this.renderDetailsHedaer()}
			</div>
		);
	};

	renderDetailsHedaerNav = ({ id }) => {
		const { unFavouriteRecipe, favouriteRecipe, getRecipeDetails, isAdmin, isfavouriteRecipe, recipeFavorite } = this.props;
		const { recipeId } = this.state;
		const successHandler = () => {
			getRecipeDetails(recipeId);
			isfavouriteRecipe(recipeId);
		};
		return (
			<div className="block-overlay-header-nav d-flex">
				{isAdmin ? (
					<Tooltip content="Edit">
						<Link to={`/nutrition/recipes/${recipeId}/edit`} className="btn btn-cell btn-light ml-2 print-hidden">
							<i className="icon icon-edit" />
						</Link>
					</Tooltip>
				) : null}
				<Tooltip content={recipeFavorite.recipe ? "Unfavorite" : "Favorite"}>
					<button
						className={`btn btn-cell ml-2 ${recipeFavorite.recipe ? "btn-primary-dark" : "btn-light"}`}
						onClick={() =>
							recipeFavorite.recipe
								? unFavouriteRecipe(recipeFavorite.id, successHandler)
								: favouriteRecipe(id, successHandler)
						}>
						<i className="icon icon-heart" />
					</button>
				</Tooltip>
				<ReactToPrint
					trigger={() => (
						<button className="btn btn-cell btn-light ml-2 print-hidden">
							<Tooltip content="Print">
								<i className="icon icon-print" />
							</Tooltip>
						</button>
					)}
					content={() => this.componentRef}
				/>
			</div>
		);
	};

	renderMainSourceText = () => {
		const { recipeDetails } = this.props;
		const { main_sources } = recipeDetails;
		if (main_sources[0]) {
			const { source__id, source__user, source__url_title, source__url } = main_sources[0];
			const notes = main_sources[0] ? (
				source__url_title ? source__url_title : null
			) : null;

			return <div className="block-value h5 text-white">{notes ? <span>From the kitchen of: {notes}</span> : null}</div>;
		}
		return null;
	};

	renderDetailsHedaer = () => {
		const { recipeDetails, recipeComments } = this.props;
		const { name, com_avg } = recipeDetails;
		const comments = recipeComments ? recipeComments.length : 0;

		return (
			<div className="block-overlay-header d-flex print-relative">
				<div className="flex-fill p-3">
					<h3 className="block-title">{name}</h3>
					{this.renderMainSourceText()}
				</div>
				<div className="p-3 text-right">
					<div className="block-item">
						<StarRating value={com_avg} />
					</div>
					<div
						className="block-value pointer"
						onClick={() =>
							this.commentDiv.scrollIntoView({
								behavior: "smooth",
								block: "start",
								inline: "nearest"
							})
						}>
						<i className="icon icon-comment" /> Read Review({comments})
					</div>
				</div>
			</div>
		);
	};

	renderDetailsCategories = ({ categories, get_range_calorie, get_range_carb, get_range_protein }) => {
		const caloriesCarbProteinData = [
			{
				icon: "icon-calories",
				data: get_range_calorie,
				unit: "kcal",
				label: "Calories"
			},
			{
				icon: "icon-carb",
				data: get_range_carb,
				unit: "grams",
				label: "Carbs"
			},
			{
				icon: "icon-protein",
				data: get_range_protein,
				unit: "grams",
				label: "Protein"
			}
		];
		return (
			<div className="block-section details-categories">
				<h4 className="title-primary-dark">Categories</h4>
				<div className="d-flex align-items-start">
					<div className="d-flex w-50 border-top-default pt-3">
						<div className="flex-fill d-flex flex-wrap">
							{categories &&
								categories.map(({ category__group__name, category__name, category__id }) => {
									return (
										<div key={category__id} className="d-flex w-50">
											<div className="w-40">{category__group__name}</div>
											<div className="flex-fill text-secondary-dark-hover bold">
												{category__name ? category__name : "--"}
											</div>
										</div>
									);
								})}
						</div>
					</div>
					<div className="d-flex flex-fill">
						{caloriesCarbProteinData.map(({ icon, data, unit, label }, index) => (
							<div key={index} className="flex-fill text-center card card-light p-2 ml-3">
								<i className={`icon lg-icon mb-2 ${icon}`} />
								<div className="h5 text-secondary-dark-hover bold m-0">
									{data} {unit}
								</div>
								<div>{label}</div>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	};

	changeServe = (event) => {
		const value = parseInt(event.target.value);
		const serveScale = value > 1 ? value : 1;
		this.setState({ serveScale, detailsActiveTab: 1 });
	};

	renderDetailsPreparation = ({ preptime, cooktime, serving_size }) => {
		const { serveScale } = this.state;
		const preparationData = [
			{
				icon: "icon-clock",
				data: preptime,
				label: "Prep Time"
			},
			{
				icon: "icon-clock",
				data: cooktime,
				label: "Cook Time"
			},
			{
				icon: "icon-food",
				data: serveScale,
				label: "Serves"
			},
			{
				icon: "icon-food",
				data: serving_size,
				label: "Serving Size"
			}
		];
		return (
			<div className="block-section details-preparation">
				<h4 className="title-primary-dark border-bottom-default pb-2">Preparation</h4>
				<div className="row">
					{preparationData.map(({ icon, data, label }, index) => (
						<div key={index} className="col-3 d-flex align-items-center">
							<i className={`icon ${icon} lg-icon mr-3`} />
							<div>
								<div className="lead text-secondary-dark-hover">
									{label === "Serves" ? (
										<input
											type="number"
											className="inline-form-control text-secondary-dark-hover text-center lead"
											value={data}
											onChange={(event) => this.changeServe(event)}
										/>
									) : (
										data
									)}
								</div>
								<div>{label}</div>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	};

	renderDetailsIngredients = ({ directions_html }) => {
		const { serveScale, recipeId, detailsActiveTab } = this.state;
		return (
			<div>
				<div className="block-section details-ingredients-directions-tab tab-primary print-hidden">
					<Tabs activeKey={detailsActiveTab} onSelect={(detailsActiveTab) => this.setState({ detailsActiveTab })}>
						<Tab eventKey={1} title="Ingredients">
							<RecipeIngredients recipeId={recipeId} scale={serveScale} />
						</Tab>
						{directions_html && (
							<Tab eventKey={2} title="Directions">
								<div className="pt-3" dangerouslySetInnerHTML={{ __html: directions_html }} />
							</Tab>
						)}
					</Tabs>
				</div>
				<div className="block-section print-only">
					<RecipeIngredients recipeId={recipeId} scale={serveScale} />
					<div className="pt-3" dangerouslySetInnerHTML={{ __html: directions_html }} />
				</div>
			</div>
		);
	};

	renderAdditionalNotes = ({ notes_html }) => {
		return notes_html ? (
			<div className="block-section details-preparation">
				<h4 className="title-primary-dark border-bottom-default pb-2">Additional Notes</h4>
				<div dangerouslySetInnerHTML={{ __html: notes_html }} />
			</div>
		) : null;
	};

	renderAcceptDeclineTab = ({ id, name, created_by, created }) => {
		return (
			<div className="card card-primary mb-3 border-0 p-3">
				<div className="row">
					<div className="col-10 border-right">
						<div className="row">
							<div className="col-1">
								<div className="recipe-approval-icon br-4 d-flex align-items-center justify-content-center h-100 w-100 ">
									<i className="icon icon-plate "></i>
								</div>
							</div>
							<div className="col-11">
								<h4 className="text-primary-dark">Patient Recipe Submission</h4>
								<div className="d-flex flex-row justify-content-between">
									{name ? (
										<div>
											<p className="mb-0">Name</p>
											<h5 className="text-primary-dark mb-0"> {name}</h5>
										</div>
									) : null}
									{created_by && created_by.first_name ? (
										<div>
											<p className="mb-0">Member</p>
											<h5 className="text-primary-dark mb-0"> {created_by.first_name}</h5>
										</div>
									) : null}

									{created ? (
										<div>
											<p className="mb-0">Date</p>
											<h5 className="text-primary-dark mb-0"> {moment(created).format("MM YYYY D")}</h5>
										</div>
									) : null}
								</div>
							</div>
						</div>
					</div>
					<div className="col-2">
						<button
							type="button"
							className="btn btn-primary-dark w-100 mb-2"
							onClick={() => this.props.history.push(`/nutrition/recipes/${id}/edit`)}>
							<i className="icon icon-check-circle"></i> APPROVE
						</button>
						<button
							type="button"
							className="btn btn-primary-dark btn-ghost w-100"
							onClick={() => this.declineRecipe(this.props.recipeDetails)}>
							<i className="icon icon-eye"></i> DECLINE
						</button>
					</div>
				</div>
			</div>
		);
	};

	declineRecipe = (cardInfo) => {
		this.setState({ showDeclineRecipePanel: true });
		this.setState({ recipeToDecline: cardInfo });
	};

	onDeclineSuccess = () => {
		this.props.history.push("/nutrition/recipes/approval");
	};

	onDeclineError = () => {
		this.setState({ showDeclineRecipePanel: false });
	};

	renderDeclineRecipePanel = () => {
		const { recipeToDecline, showDeclineRecipePanel } = this.state;
		return (
			<FilterPanel
				show={showDeclineRecipePanel}
				toggle={() => this.setState({ showDeclineRecipePanel: !showDeclineRecipePanel })}
				title="Decline Recipe"
				closeBtn>
				{recipeToDecline && (
					<DeclineRecipePanel onUpdate={this.onDeclineSuccess} onError={this.onDeclineError} data={recipeToDecline} />
				)}
			</FilterPanel>
		);
	};

	handleCancel = () => {
		this.setState({ selectedRecipe: null });
	};

	render() {
		const { recipeDetails, isAdmin } = this.props;
		const { recipeId, selectedRecipe } = this.state;

		return (
			<section className="page page-recipes-details" ref={(event) => (this.page = event)}>
				<div className="container">
					{isAdmin && recipeDetails.active === false ? this.renderAcceptDeclineTab(recipeDetails) : null}
					<div className="row" ref={(el) => (this.componentRef = el)}>
						<div className="col-9">
							{recipeDetails && recipeDetails.id ? (
								<div className="block block-primary">
									{this.renderImageContainer()}
									{this.renderDetailsCategories(recipeDetails)}
									{this.renderDetailsPreparation(recipeDetails)}
									{this.renderDetailsIngredients(recipeDetails)}
									{this.renderAdditionalNotes(recipeDetails)}
									<div className="print-hidden">
										<RecipeCreateComment recipeId={recipeId} />
									</div>
									<div ref={(event) => (this.commentDiv = event)} className="print-hidden">
										<RecipeComments recipeId={recipeId} />
									</div>
								</div>
							) : (
								<div className="alert alert-info text-center">Loading content...</div>
							)}
						</div>
						{recipeId && (
							<div className="col-3">
								{recipeDetails.active ? (
									<button
										className="btn btn-primary-dark w-100 mb-4 print-hidden"
										onClick={() => this.setState({ selectedRecipe: recipeDetails })}>
										Journal This
									</button>
								) : null}
								<div className="block block-primary p-3 mb-3">
									<h4 className="title-primary-dark">Nutrition Facts</h4>
									<RecipeNutritionFacts recipeId={recipeId} />
								</div>
								<div className="block block-primary p-3 mb-3">
									<h4 className="title-primary-dark">Servings Of</h4>
									<RecipeServings recipe={recipeDetails} />
								</div>
								<div className="block block-primary p-3 mb-3 print-hidden">
									<RecentRecipes recipeId={recipeId} />
								</div>
								<div className="block block-primary p-3 mb-3 print-hidden">
									<RelatedRecipes recipeId={recipeId} />
								</div>
							</div>
						)}
					</div>
					{selectedRecipe && (
						<AddToJournal
							initialRecipe={selectedRecipe}
							toggleAddToJournal={true}
							setToggleAddToJornal={this.handleCancel}
						/>
					)}
				</div>
				{this.renderDeclineRecipePanel()}
			</section>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		recipeDetails: get(state, "Recipes.recipeDetails", []),
		recipeFavorite: get(state, "Recipes.recipeFavorite", {}),
		recipeComments: get(state, "Recipes.recipeCommentsResult.results", []),
		isAdmin: get(state, "Auth.isAdmin", false),
		userDetails: state.Auth.userDetails
	};
};

const mapDispatchToProps = { getRecipeDetails, resetField, favouriteRecipe, unFavouriteRecipe, isfavouriteRecipe };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RecipeDetails);
